import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useUISettings } from '../../context/UISettingsContext';
import { Button } from './Button';

export function AppLockScreen() {
  const { logout } = useAuth();
  const { setIsPinModalOpen } = useUISettings();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-2xl text-center">
        <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-gray-600" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold mt-4">App Locked</h2>
        <p className="text-gray-600 mt-2">Enter your PIN to unlock</p>
        <Button
          onClick={() => setIsPinModalOpen(true)}
          variant="primary"
          className="mt-4"
        >
          Enter PIN
        </Button>
        <button
          onClick={logout}
          className="mt-4 text-red-500 hover:text-red-600 block w-full text-sm"
        >
          Logout
        </button>
      </div>
    </div>
  );
}